import { Box, Tabs, Tab } from "@mui/material";
import TabPanel from "../TabPanel";
import BallotOutlinedIcon from "@mui/icons-material/BallotOutlined";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ConnectionScreen from "./ConnectionScreen";

const PDCConnection = ({ handleClose, dir = 'IN', pdcName = '', screen, origin, onPdcSelect, source }) => {
    const { t } = useTranslation();
    const [currTab, setCurrTab] = useState(0);

    const handleTabChange = (event, newValue) => {
        setCurrTab(newValue);
    };

    useEffect(() => {
        if (dir === 'OUT') setCurrTab(1);
        else setCurrTab(0);
    }, [dir])

    return (
        <>
            <div style={{ height: "calc(100% - 60px)"}}>
                <Box className= "font-12 padding-12">
                    {t('PDC_DESC')}
                </Box>
                <Box sx={{ padding: '2px 10px 0 10px', height:'100%'}}>
                    <Box sx={{ border: 1, borderColor: "divider" }}>
                        <Tabs
                            sx={{ backgroundColor: "#fff" }}
                            value={currTab}
                            onChange={handleTabChange}
                        >
                            <Tab
                                label={
                                    <div className="flex align-center">
                                        <BallotOutlinedIcon size="small" className="margin-right-4" />
                                        {t('PDC_DATA_SRC_CONN')}
                                    </div>
                                }
                            />
                            <Tab
                                label={
                                    <div className="flex align-center">
                                        <BallotOutlinedIcon size="small" className="margin-right-4" />
                                        {t('PDC_DATA_DEST_CONN')}
                                    </div>
                                }
                            />
                        </Tabs>
                    </Box>
                    <Box className="height-100-tab width-100">
                        <TabPanel className="height-100 width-100" value={currTab} index={0}>
                            <ConnectionScreen direction={t('PDC_IN')} currTab={currTab} handleClose={handleClose} pdcConnectionName={pdcName} screen={screen} origin={origin} onPdcSelect={onPdcSelect} source={source} />
                        </TabPanel>
                        <TabPanel className="height-100 width-100" value={currTab} index={1}>
                            <ConnectionScreen direction={t('PDC_OUT')} currTab={currTab} handleClose={handleClose} pdcConnectionName={screen === "GET_DATA" ? "" : pdcName} screen={screen} origin={origin} onPdcSelect={onPdcSelect} source={source} />
                        </TabPanel>
                    </Box>
                </Box>
            </div>
        </>
    )
}

export default PDCConnection